<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28 31.578">
        <g id="Group_2686" data-name="Group 2686" transform="translate(-312 -452)">
            <circle id="Ellipse_188" data-name="Ellipse 188" cx="14" cy="14" r="14" transform="translate(312 452)"
                    fill="#cedbff"/>
            <g id="Group_2566" data-name="Group 2566" transform="translate(298 454)">
                <g id="dropper" transform="translate(14.262 4.453)">
                    <path id="Path_69772" data-name="Path 69772"
                          d="M44.718,16.4a1.318,1.318,0,0,0,.934-.386l.594-.594a1.323,1.323,0,0,0,1.743-.111l5.37-5.37.6.6a.4.4,0,0,0,.571,0l1.595-1.595a.4.4,0,0,0,0-.571L55.756,8l3.266-3.266A2.777,2.777,0,0,0,55.094.809L51.829,4.075,51.456,3.7a.4.4,0,0,0-.571,0L49.291,5.3a.4.4,0,0,0,0,.571l.6.6-5.37,5.37a1.323,1.323,0,0,0-.143,1.7l-.6.6a1.321,1.321,0,0,0,.934,2.255ZM55.665,1.38a1.97,1.97,0,1,1,2.786,2.786L55.185,7.431,52.4,4.645ZM51.171,4.558l4.1,4.1L54.248,9.684l-.557-.557a.4.4,0,0,0-.1-.1L50.8,6.239a.4.4,0,0,0-.1-.1l-.557-.557ZM44.354,14.712l.872-.872a.4.4,0,0,0,0-.571l-.13-.13a.515.515,0,0,1,0-.727l5.37-5.37,2.322,2.322-5.37,5.37a.515.515,0,0,1-.727,0l-.167-.167a.4.4,0,0,0-.571,0l-.871.871a.514.514,0,1,1-.727-.727Zm0,0"
                          transform="translate(-41.208 0)" fill="#799cfb"/>
                    <path id="Path_69773" data-name="Path 69773"
                          d="M3.258,342.248A3.277,3.277,0,0,0,6.09,340.6,2.918,2.918,0,0,0,6.1,337.64l-.02-.031-2.5-3.474a.4.4,0,0,0-.328-.163h0a.4.4,0,0,0-.328.163L.433,337.6c-.007.01-.015.02-.021.031A2.932,2.932,0,0,0,.429,340.6a3.276,3.276,0,0,0,2.829,1.647ZM1.1,338.054l2.157-3,2.158,3.007a2.093,2.093,0,0,1-.026,2.131,2.446,2.446,0,0,1-4.261,0,2.107,2.107,0,0,1-.028-2.144Zm0,0"
                          transform="translate(-0.017 -317.123)" fill="#799cfb"/>
                    <path id="Path_69774" data-name="Path 69774"
                          d="M56.279,428.732a1.917,1.917,0,0,0,1.919-1.911.4.4,0,0,0-.807,0,1.108,1.108,0,0,1-1.112,1.1.4.4,0,0,0,0,.807Zm0,0"
                          transform="translate(-53.057 -404.906)" fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ITest",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
